import type { MouseEvent } from "react";

import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";
import { FileIcon } from "lucide-react";

import { Icon } from "simplydo/react/ui/icon";

import type { FileAttrs, FileOptions } from "../extensions/file";

export const FileNodeView = ({
  node,
  editor,
  extension,
}: ReactNodeViewProps) => {
  const { src, name } = node.attrs as FileAttrs;
  const options = extension.options as FileOptions;

  const onClick = (event: MouseEvent) => {
    // Keep selection/rename behaviour in the editor; never navigate.
    if (editor.isEditable) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    // Left-click uses the cookie download flow; href stays for
    // right-click "Copy link address" / open in new tab.
    event.preventDefault();
    event.stopPropagation();
    options.onClick?.(src, { src, name });
  };

  return (
    <NodeViewWrapper
      as="a"
      href={src}
      rel="noopener noreferrer"
      target="_blank"
      data-ext="file"
      onClick={onClick}
    >
      <span className="file-node-view-spacer file-node-view-spacer-left">
        &nbsp;
      </span>
      <Icon icon={FileIcon} />
      {name}
      <span className="file-node-view-spacer file-node-view-spacer-right">
        &nbsp;
      </span>
    </NodeViewWrapper>
  );
};
